export default function reloadOnce() {
  console.log("about to reload");
  return window.location.reload();
}
